import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils/cn";
import { NAV_ITEMS } from "./navigation";

export function NavList({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <nav aria-label="Navegacion principal" className="flex flex-col gap-1 px-3">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          onClick={onNavigate}
          className={({ isActive }) =>
            cn(
              "flex min-h-11 items-center gap-3 rounded-lg px-3 py-3 text-sm font-medium transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-900",
              isActive
                ? "bg-brand-700 text-white"
                : "text-white/85 hover:bg-brand-800/60 hover:text-white",
            )
          }
        >
          {({ isActive }) => (
            <>
              <item.icon
                className={cn("h-4.5 w-4.5 shrink-0", isActive ? "text-white" : "text-brand-200")}
                style={{ height: "1.125rem", width: "1.125rem" }}
                aria-hidden="true"
              />
              {item.label}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
